import {adicRestApi, adicRestApiLitUrl} from '../index';

export const getLitList = async (category, query) => {
  const url = adicRestApiLitUrl
    .segment("/:category/list")
    .param({
      category:category
    })
    .query(query)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getLitDetail = async (category, query) => {
  const url = adicRestApiLitUrl
    .segment("/:category/info")
    .param({
      category:category
    })
    .query(query)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getPaperList = async (paperUrl) => {
  const url = adicRestApiLitUrl
    .segment("/paper/list")
    .query(paperUrl)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getPaperDetail = async (ukey) => {
  const url = adicRestApiLitUrl
    .segment("/paper/info")
    .query(ukey)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getReportList = async (reportUrl) => {
  const url = adicRestApiLitUrl
    .segment("/report/list")
    .query(reportUrl)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getReportDetail = async (ukey) => {
  const url = adicRestApiLitUrl
    .segment("/report/info")
    .query(ukey)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getJournalList = async (journalUrl) => {
  const url = adicRestApiLitUrl
    .segment("/journal/list")
    .query(journalUrl)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getJournalDetail = async (ukey) => {
  const url = adicRestApiLitUrl
    .segment("/journal/info")
    .query(ukey)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};
